import axios from "axios";
import i18n from "@/lib/i18n";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    withCredentials: true,
});

export function formatApiErrorDetail(detail) {
    if (detail == null) return i18n.t("Qualcosa è andato storto. Riprova.");
    if (typeof detail === "string") return i18n.t(detail);
    if (Array.isArray(detail))
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .filter(Boolean)
            .join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}

export async function uploadImage(file) {
    const fd = new FormData();
    fd.append("file", file);
    const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
    return data.url;
}

export const money = (amount, symbol = "€") => `${symbol}${amount}`;

export function getApiErrorMessage(err, fallback) {
    if (err?.response) {
        const detail = err.response.data?.detail;
        if (detail != null) return formatApiErrorDetail(detail);
        if (err.response.status === 429) return i18n.t("Troppi tentativi. Riprova tra qualche minuto.");
        return i18n.t("Errore del server ({{status}}). Riprova.", { status: err.response.status });
    }
    if (err?.request) return i18n.t("Impossibile contattare il server. Controlla la connessione e riprova.");
    return err?.message || fallback || i18n.t("Qualcosa è andato storto. Riprova.");
}
